import { render } from "./DataLazy.vue?vue&type=template&id=08bf6ce8"
import script from "./DataLazy.vue?vue&type=script&lang=js"
export * from "./DataLazy.vue?vue&type=script&lang=js"

import "./DataLazy.vue?vue&type=style&index=0&id=08bf6ce8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__